module.exports = __webpack_public_path__ + "media/images/logo_default-1285fa784d4f0831e511ac26ad79c8e9.svg";